import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { removeToken } from "../../utils/auth";
import { subscribeAccountArchived } from "../../utils/archivedAccount";
import ArchivedAccountScreen from "./ArchivedAccountScreen";

// Mounted once, high in the tree (see App.js) so it applies regardless of which
// route the user is on when the 410 lands. Subscribes to the account_archived
// signal the axios interceptor emits (src/utils/auth.js) and renders the
// full-screen explanation in place of the app.
//
// A user who belongs to a LIVE workspace as well as the archived one never
// reaches this: the 410 is only raised for the client the request is scoped to,
// and list endpoints filter archived workspaces out rather than refusing (see
// the fan-out exception in Api::V1::BaseController). So this fires only when
// the workspace they are working in was frozen because its whole BILLING
// ACCOUNT was archived (410 account_archived). A single workspace archived on
// its own returns 410 workspace_archived instead, which does not lock the app:
// WorkspaceArchivedListener moves the user to another live workspace.
export default function ArchivedAccountGate({ children }) {
  const [archivedInfo, setArchivedInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => subscribeAccountArchived(setArchivedInfo), []);

  const handleSignOut = () => {
    removeToken();
    setArchivedInfo(null);
    navigate("/login");
  };

  if (archivedInfo) {
    return (
      <ArchivedAccountScreen
        message={archivedInfo.message}
        onSignOut={handleSignOut}
      />
    );
  }

  return children;
}
